export class UserSession {
    userId: number;
    userFullName: string;
    roleId: number;
    authToken: string;
    roleName: string;
    email: string;
    mobileNumber: string;
    departmentName: string;
    departmentId: number;
    isDynamicPassword: boolean;
  }
